fragment NextStepsSlackMessageFragment on FormNextStepsSlackMessage {
    id
    channelId
    position
    slackChannel {
        display
        externalId
        name
    }
    form {
        id
    }
}
